module.exports = __webpack_public_path__ + "static/media/DM3 Static Test.28483823.jpg";